import { CupModeFormatBase } from "./CupModeFormat";

export type ReverseCupModeFormat = CupModeFormatBase & {
  lastChance: boolean;
  requiredTeamLosers: number | undefined;
  saviourMode: boolean;
  startingPoints: number;
  startingPointsOverrides?: { [rosterId: string]: number };
};

export const getRosterStartingPoints = (
  format: ReverseCupModeFormat,
  rosterId: string
) => format.startingPointsOverrides?.[rosterId] ?? format.startingPoints;
